import React from "react";
import "./Unauthorized.css";

const Unauthorized = () => {
  return (
    <section className="unauthorized-container">
      <header className="unauthorized-header">
        <span className="unauthorized-heading">You do not have permission to view this page.</span>
      </header>
    </section>
  );
};

export default Unauthorized;